
<div class="row p-0 mb-2">
  <div class="col-md-3">
    <app-select-academic-year-only (academicYearChanged)="onChangeAcademicYear($event)" [clear]="false">
    </app-select-academic-year-only>
  </div>
</div>
<div class="row p-0 mb-4">
    <div class="col-md-7 d-flex mb-3 mb-md-0">
        <app-participant-graph class="w-100" [academic_year]="academicYear"></app-participant-graph>
    </div>
    <div class="col-md-5 d-flex">
        <app-school-program-information class="w-100" [academic_year]="academicYear"></app-school-program-information>
    </div>
</div>
<div class="row p-0">
  <div class="col-md-6">
    <app-school-program-category-chart [academic_year]="academicYear"></app-school-program-category-chart>
  </div>
  <div class="col-md-6">
    <app-school-program-attendance-chart [academic_year]="academicYear"></app-school-program-attendance-chart>
  </div>
</div>


<div class="row p-0">
  <div class="col-md-12">
    <app-school-program-activity></app-school-program-activity>
  </div>
  <!-- <div class="col-md-4">
    <app-product></app-product>
  </div> -->
</div>


<!-- <app-cards></app-cards> -->
